module.exports = __webpack_public_path__ + "static/media/bowling-pins.3c700f1f.svg";